import { SidebarMenuButton, SidebarMenuItem } from '@nesso/ui/primitives/sidebar';
import { Skeleton } from '@nesso/ui/primitives/skeleton';

export function TodaySessionsItemSkeleton() {
    return (
        <SidebarMenuItem className="py-1">
            <SidebarMenuButton className="justify-between px-2 h-[54px]" disabled>
                <div className="flex min-w-0 flex-col text-left gap-2">
                    <Skeleton className="h-4 w-[180px]" />
                    <Skeleton className="h-3 w-[160px]" />
                </div>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
}
